import { useQuery } from 'react-query';

import { DocWithCasesResponseDto } from '../../../../backend/src/case/doc/dto/doc-with-cases.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterDocsWithCases = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DocWithCasesResponseDto[]>(
    [QueryEntity.MatterDocsWithCases, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/docs-with-cases`, fetchConfigGET).then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
